module.exports = __webpack_public_path__ + "img/display-round-table.daa69c63.jpg";